angular.module('pitch.app')
.controller('FooterCtrl', function($scope, $controller, SiteContext) {
    "use strict";

    angular.extend(this, $controller('MainMenuCtrl', {
        $scope: $scope
    }));

    SiteContext.get().then(function(r) {
        $scope.site = r;
        if ($scope.site) {
            $scope.isUSASite = $scope.site.name.match(/USA|NASHVILLE|LATIN/i) !== null;
            $scope.isUSAorCanadaSite = $scope.site.name.match(/USA|NASHVILLE|LATIN|CANADA/i) !== null;
            $scope.isUKSite = $scope.site.name.match(/UK/i) !== null;
        }
    });
});



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/controllers/FooterCtrl.js